import { createContext, useContext } from 'react';

import type {
  ColorPalette,
  CustomColorPalette,
} from '../../core/types/color-palette.js';
import { ColoredRange } from '../../core/types/colored-range.js';

export const ColorPaletteContext = createContext<
  ColorPalette | CustomColorPalette | ColoredRange[]
>({});

export const useColorPalette = () => useContext(ColorPaletteContext);

ColorPaletteContext['displayName'] = 'ColorPaletteContext';
